import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { BatchAlertService } from 'src/app/services/batch-alert.service';
import { RootScopeService } from 'src/app/services/root-scope.service';


@Component({
  selector: 'app-view-participants',
  templateUrl: './view-participants.component.html',
  styleUrls: ['./view-participants.component.scss']
})

export class ViewParticipantsComponent implements OnInit, AfterViewInit {
  iconConfig: any;
  totalRecords: number = 0;
  @ViewChild('fileInput')
  public currentColumns1 = [
    { field: 'globalUDPId', header: 'Global UDP ID', width: 100 },
  ];

  public displayedColumns: string[] = this.currentColumns1.map(col => col.field);
  public pageSize = 10;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  pageIndex = 0;
  allFetchedData: any[] = [];
  selectedRow: any;
  public recordCount:number = 0;
  skipCount = 0;
  currentPageStartIndex = 0
  public dataSource = new MatTableDataSource<any>([]);
  start: number = 0;
  end: number = 0;
  isNextDisabled = false;
  isPreviousDisabled = true;
  pageNumbers: number[] = [];
  visiblePageNumbers: number[] = [];

  constructor(public batchAlertService: BatchAlertService, public rootService: RootScopeService) {
    this.iconConfig = {
      iconName: 'xmark',
      iconType: 'light'
    }
  }


  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  
  ngOnInit(): void {
    this.selectedRow = this.batchAlertService?.currentBatchSelectedRow;
    this.totalRecords = this.selectedRow?.alertCount;
    this.recordCount = this.batchAlertService.recordCountBatchAlert;
    this.loadData();
    this.calculatePageNumbers();
  }

  loadData() {
    this.batchAlertService.fetchandUpdateViewParticipantData(
      this.selectedRow?.externalRefId,
      this.recordCount,
      this.skipCount
    );

    this.batchAlertService.viewParticipantData$.subscribe((transformedData: any[]) => {
      this.allFetchedData = transformedData;
      this.updateDisplayedData();
    });
  }

  calculatePageNumbers() {
    const totalPages = Math.ceil(this.totalRecords / this.pageSize);
    this.pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    this.updateVisiblePageNumbers();
  }

  updateVisiblePageNumbers() {
    const totalPages = this.pageNumbers.length;
    const start = Math.max(0, this.pageIndex - 1);
    const end = Math.min(totalPages, start + 4);

    this.visiblePageNumbers = this.pageNumbers.slice(start, end);
    this.isPreviousDisabled = this.pageIndex === 0;
    this.isNextDisabled = this.pageIndex === totalPages - 1;
  }

  
  goToPageChange(pageNum: number) {
    this.pageIndex = pageNum - 1;
    this.handlePageChange();
  }

  handlePageChange() {
    const absolutePageIndex = this.pageIndex * this.pageSize;
    const targetChunkStart = Math.floor(absolutePageIndex / this.recordCount) * this.recordCount;

    if (targetChunkStart !== this.skipCount) {
      this.skipCount = targetChunkStart;

      // Fetch the new chunk
      this.batchAlertService.fetchandUpdateViewParticipantData(
        this.selectedRow?.externalRefId,
        this.recordCount,
        this.skipCount
      );
    } else {
      // If still within the current chunk, just update the displayed data
      this.updateDisplayedData();
    }
    this.updatePaginatorState();
    this.updateVisiblePageNumbers();
  }


  updateDisplayedData() {
    this.start = this.pageIndex * this.pageSize;
    this.end = this.start + this.pageSize;

    // Compute start and end relative to the chunk
    const chunkRelativeStart = this.start - this.skipCount;
    const chunkRelativeEnd = this.end - this.skipCount;

    // Ensure we slice only within the available fetched data
    const slicedData = this.allFetchedData?.slice(
      Math.max(0, chunkRelativeStart),
      Math.min(this.recordCount, chunkRelativeEnd)
    );

    this.dataSource.data = slicedData; // Update dataSource with the sliced data
  }

  updatePaginatorState() {
    this.isPreviousDisabled = this.pageIndex === 0;
    this.isNextDisabled = (this.pageIndex + 1) * this.pageSize >= this.totalRecords;
  }
  // Custom pagination buttons
  goToFirstPage() {
    this.pageIndex = 0;
    this.handlePageChange();
  }

  goToPreviousPage() {
    if (this.pageIndex > 0) {
      this.pageIndex--;
      this.handlePageChange();
    }
  }

  goToNextPage() {
    const totalPages = Math.ceil(this.totalRecords / this.pageSize);
    if (this.pageIndex < totalPages - 1) {
      this.pageIndex++;
      this.handlePageChange();
    }
  }

  goToLastPage() {
    this.pageIndex = Math.ceil(this.totalRecords / this.pageSize) - 1;
    this.handlePageChange();
  }

  closeViewParticipantModal() {
    this.rootService.openViewParticipant = false;
  }

}
